module.exports = __webpack_public_path__ + "media/images/glossy_logo-67d2bd4ccde838246660ccc82b89e4f7.png";